import { render } from "./MainMod.vue?vue&type=template&id=1d72be55&scoped=true"
import script from "./MainMod.vue?vue&type=script&lang=js"
export * from "./MainMod.vue?vue&type=script&lang=js"

import "./MainMod.vue?vue&type=style&index=0&id=1d72be55&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d72be55"]])

export default __exports__